module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": true,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 row-rm-padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  }, [_c('div', [_c('h3', [_c('button', {
    staticClass: "btn primary-btn-my clear-new-modal",
    staticStyle: {
      "float": "left",
      "margin-bottom": "15px",
      "margin-left": "15px"
    },
    on: {
      "click": _vm.activateUsers
    }
  }, [_vm._v("Activate")])]), _vm._v(" "), _c('button', {
    staticClass: "btn primary-btn-my",
    staticStyle: {
      "float": "right",
      "margin-bottom": "15px",
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.genarateUsersListPDF.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.usersList.buttonLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn primary-btn-my",
    staticStyle: {
      "float": "right",
      "margin-bottom": "15px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.genarateMarktingAgreedUsersListPDF.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.usersMCAgreedList.buttonLabel))]), _vm._v(" "), _c('sync-loader', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "loading": _vm.userListLoading,
      "color": '#FECD2F',
      "size": '10px',
      "width": '5px',
      "margin": '2px'
    }
  })], 1)])])]), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.activeModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.activeModal = $event
      },
      "update:md-active": function($event) {
        _vm.activeModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Activate Users\n      "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activeModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "from-padding modal-width-100"
  }, [(this.errorActive) ? _c('div', {
    staticClass: "error-acction"
  }, [_c('p', [_vm._v("The Selected Users are already assigned to one or more Organisations. Please select users that have not been assigned to an Organisation OR only Users assigned to a single Organisation for each Bulk Activation.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left-select"
  }, [_c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Supervisor")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "superuser_id",
      "id": "superuser_id",
      "disabled": _vm.isDisabledSup
    },
    model: {
      value: (_vm.activeUserData.superuser),
      callback: function($$v) {
        _vm.$set(_vm.activeUserData, "superuser", $$v)
      },
      expression: "activeUserData.superuser"
    }
  }, _vm._l((_vm.getSupervisorList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-select"
  }, [_c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('md-select', {
    staticClass: "organization_id",
    attrs: {
      "name": "organization_id",
      "id": "organization_id",
      "disabled": _vm.isDisabledOrg
    },
    on: {
      "md-selected": function($event) {
        return _vm.loadSuperUsers(_vm.activeUserData.organization)
      }
    },
    model: {
      value: (_vm.activeUserData.organization),
      callback: function($$v) {
        _vm.$set(_vm.activeUserData, "organization", $$v)
      },
      expression: "activeUserData.organization"
    }
  }, _vm._l((_vm.getOrganizationList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.activateUsersAPI
    }
  }, [_vm._v("\n          Activate User\n        ")]), _vm._v("\n           \n        "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.newModalLoading,
      "color": _vm.newModalColor,
      "size": _vm.newModalSize,
      "width": _vm.newModalWidth,
      "margin": _vm.newModalMargin
    }
  })], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable",
    attrs: {
      "id": "example"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_c('input', {
    staticClass: "datatable-check-list",
    attrs: {
      "type": "checkbox",
      "id": "select-all",
      "value": "all"
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "182px"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "142px"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Org-Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Organization")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Supervisor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Marketing Communications")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "101px"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b4393a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/UserView.vue
// module id = 2077
// module chunks = 1